import { useContext } from 'react';
import { DocumentDataContext } from "../context/document-data.js";
export const useDocumentData = () => useContext(DocumentDataContext);
//# sourceMappingURL=use-document-data.js.map